<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start">
                                <strong>{{$t('addContact')}}</strong>
                            </CCol>
                            <CCol col="4" style="text-align: end">
                                <CButton v-if="status_form ==0" class="mr-1 ml-1" @click="insert_data(true)"
                                         type="submit" size="sm" color="secondary">
                                    {{ $t('buttons.submit') }}
                                </CButton>


                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>

                            <CCol sm="3">
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="12" class="">
                                        {{$t('name')}}
                                    </CCol>
                                    <CCol sm="12">

                                        <treeselect
                                                v-model="document_person_id"
                                                :options="searched_person"
                                                @select="select_user"
                                                :resetSearchOnClose="false"
id="user_search"
                                                :async="search_user_async"
                                                :load-options="load_persons"
                                                :placeholder="$t('components.search')"
                                                :normalizer="normalizer_persons"
                                        />

                                    </CCol>
                                </CRow>

                            </CCol>
                            <CCol sm="3">
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="12" class="">
                                        {{$t('mobile')}}
                                    </CCol>
                                    <CCol sm="12">
                                        <CInput
                                                v-on:keypress="isNumber($event)"
maxlength="11"
                                                v-model="document_person_mobile"
                                                :disabled="document_person_id!=null"
                                        />

                                    </CCol>
                                </CRow>

                            </CCol>
                            <CCol sm="3">
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="12" class="">
                                        {{$t('components.company')}}
                                    </CCol>
                                    <CCol sm="12">
                                        <CInput
                                              v-model="company_name"
                                        />
                                    </CCol>
                                </CRow>

                            </CCol>
                            <CCol sm="3">
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="12" class="">
                                        {{$t('Relationship')}}
                                    </CCol>
                                    <CCol sm="12">
                                        <CSelect
                                                :value.sync="emergency_relationship"
                                                :options="emergency_relationships"
                                        />
                                    </CCol>
                                </CRow>

                            </CCol>

                        </CRow>
                    </CCardBody>
                </CCard>

            </CCol>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('ListContact')}}</strong>
                    </CCardHeader>
                    <CCardBody>

                        <CDataTable
                                :items="filtered_items"
                                :fields="fields"
                                striped
                                column-filter
                                border
                                :items-per-page="20"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item,index}">

                                <td>
                                    <p style="text-align: center">{{ index + 1 }}</p>

                                </td>

                            </template>


                            <template #isCashier="{item}">

                                <td>
                                    <div>
                                        {{ get_type(item) }}
                                    </div>
                                </td>

                            </template>
                            <template #operation="{item}">
                                <td>
                                    <CIcon @click.native="delete_item_dialog(item)" class="text-danger"
                                           name="cilTrash"/>
                                    <CIcon @click.native="edit_item(item)" class="text-warning"
                                           name="cil-pencil"/>
                                </td>
                            </template>


                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>

        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    // import the styles
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,

        },
        data() {
            return {
                company_name:'',
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                emergency_relationships: [],
                emergency_relationship: '',
                validate_errors: [],
                name_tankhah: '',
                name: '',
                description_tankhah: '',
                description: '',
                selected_branch: '',
                selected_bank: '',
                cashier_no: '',
                sheba_no: '',
                branch_items: [],
                bank_items: [],
                searched_person: [],
                document_person_mobile: "",
                document_person_name: "",
                document_person_tankhah: null,
                document_person_id: null,
                search_user_async: true,
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.userName + " " + node.surName,
                   mobile:node.mobileNo
                    }
                },
                items: [],
                filtered_items: [],
                fields: [
                    {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
                    {key: 'contactName', label: this.$t('name'), _style: 'width:10%'},
                    {key: 'contactMobile', label: this.$t('mobile'), _style: 'width:10%'},
                    {key: 'company', label: this.$t('components.company'), _style: 'width:10%'},
                    {key: 'relationshipName', label: this.$t('Relationship'), _style: 'width:10%'},
                    {key: 'operation', label: "", filter: false, _style: 'width:5%;'},
                ],

                cashier_types: [
                    {label: this.$t('all'), value: 0},
                    {label: this.$t('components.cashier'), value: 1},
                    {label: this.$t('components.salary'), value: 2}
                ],
                selected_cashier_type: 0,
                status_form: 0,
                all_accounting_list: [],
                filtered_accounting_list: [],

            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];

            this.get_lists();
            this.get_sys();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            'selected_cashier_type': function () {
                if (this.selected_cashier_type == 0) {
                    this.filtered_items = this.items;
                } else if (this.selected_cashier_type == 1) {
                    this.filtered_items = this.items.filter(item => item.isCashier == true);
                } else if (this.selected_cashier_type == 2) {
                    this.filtered_items = this.items.filter(item => item.isCashier == false);
                }
            },

        },
        methods: {
            load_persons({action, searchQuery, callback}) {
var self = this;
                if (action === ASYNC_SEARCH) {
                    simulateAsyncOperation(() => {
                        let options;
                        const formData = new FormData();

                        formData.append('SearchTxt', searchQuery);
                        var url = "GetAllPersons";
                        self.document_person_name = searchQuery
                        formData.append('IsVendor', true);
                        formData.append('IsWorker', true);
                        formData.append('IsCustomer', true);
                        formData.append('IsActive', 0);

                        axios.post(url, formData, {show_pros: true}).then(function (response) {
                            options = response.data.data;

                            callback(null, options);

                            // localStorage.setItem("api_token", response.data.access_token);
                            // self.$router.push({ path: 'notes' });
                        })
                            .catch(function (error) {
                                console.log(error);
                            });
                    })
                }
            },

            validateForm: function () {
                this.$root.root_validate_errors = [];
                // return true;

                if(this.document_person_id == null && this.document_person_name != null
                    && this.document_person_name != '') {
                    return true;
                }else if(this.document_person_id != null ) {
                    return true;
                }else{
                    this.$root.root_validate_errors.push(this.$t('dialogs.selectUser'));

                }

                return false;
                // e.preventDefault();
            },
            select_user(node) {
                console.log("user select ",node)
                this.document_person_id = node.userId
                this.document_person_mobile = node.mobileNo
                this.document_person_name = node.userName + " " + node.surName

            },
            get_type(item) {
                if (item.isCashier) {
                    return this.$t('components.cashier')
                } else {
                    return this.$t('components.salary')

                }

            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)

                this.company_name = item.company;
                this.search_user_async = false;
                if(item.contactId==0){
                    this.document_person_id = null;
                    document.getElementById('user_search').getElementsByTagName('input')[0].value = item.contactName
                    document.getElementById('user_search').getElementsByClassName('vue-treeselect__placeholder')[0].classList.add('vue-treeselect-helper-hide')
                }else{
                    document.getElementById('user_search').getElementsByTagName('input')[0].value = ""
                    document.getElementById('user_search').getElementsByClassName('vue-treeselect__placeholder')[0].classList.add('vue-treeselect-helper-hide')
                    this.document_person_id = item.contactId;
                }
                this.document_person_name = item.contactName;
                this.document_person_mobile = item.contactMobile;

                this.emergency_relationship = item.relationshipId;

                this.searched_person = [{
                    userId: item.contactId,
                    userName: item.contactName,
                    surName:"",
                    mobileNo:item.contactMobile,
                }];
                var self = this;
                this.table_clicks_timer = setTimeout(() => {
                    // this.result.push(event.type);
                    self.search_user_async = true;
                }, 500);
                this.status_form = item.id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;
                this.search_user_async = true;
                this.document_person_id = null;
                this.document_person_mobile = null;
                this.document_person_name = null;
                this.name = null;
                this.description = null;
                this.selected_branch = null;
                this.selected_bank = null;
                this.cashier_no = null;
                this.sheba_no = null;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);

                axios.post('GetPersonUserContacts', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.filtered_items = self.items;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_sys() {
                var self = this;

                const formData = new FormData();

                axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;

                    self.emergency_relationships = [];
var emer = []
                    content_data.forEach((val) => {
                        var obj = {label: val.title, value: val.id}
                        if (val.titleType == 16) {
                            self.emergency_relationships.push(obj);
                        }
                    });
                    self.emergency_relationships = self.sort_array([],self.emergency_relationships,"value","label");

                    self.emergency_relationship = self.emergency_relationships[0].value
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },


            insert_data(type) {

                if (!this.validateForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }


                let self = this;
                const formData = new FormData();
                let url;
                if(this.status_form==0){
                    url = "AddPersonUserContact";
                }else{
                    url = "EditPersonUserContact";
                    formData.append('id', this.status_form);
                }


                formData.append('ContactName', this.document_person_name);
                if(this.document_person_id==null){
                    formData.append('ContactId', 0);
                }else{
                    formData.append('ContactId', this.document_person_id);
                }
                formData.append('ContactMobile', this.document_person_mobile);
                formData.append('RelationshipId', this.emergency_relationship);
                formData.append('Company', this.company_name);


                // formData.append('BoxCode', this.cashier_no);
                // formData.append('BranchId', this.selected_branch);
                // formData.append('IsCashier', type);

                // formData.append('AreaId', this.selected_area);
                axios.post(url, formData, {}).then((res) => {

                    self.status_form = 0;
                    self.name = '';
                    self.name_tankhah = '';
                    self.company_name = '';
                    self.description = '';
                    self.description_tankhah = '';
                    self.get_lists();
                    self.search_user_async = true;
                    self.document_person = null;
                    self.document_person_name = "";
                    self.document_person_mobile = "";
                    self.document_person_tankhah = null;
                    self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            delete_item_dialog(item) {

                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.boxTitle]), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.id;

            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DelPersonUserContact";
                formData.append('Id', this.status_form);

                axios.post(url, formData, {}).then((res) => {
                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        }
    }

</script>
